export function resolveTriviaFanPick({
  previewPick,
  serverChoiceId,
  optimisticChoiceId,
}: {
  previewPick?: string | null;
  serverChoiceId?: string | null;
  optimisticChoiceId?: string | null;
}): string | null {
  return previewPick ?? serverChoiceId ?? optimisticChoiceId ?? null;
}

export function choiceIdFromSubmitResult(
  data:
    | {
        triviaSubmitAnswer?: { questionId: string; choiceId: string } | null;
      }
    | null
    | undefined,
): string | null {
  return data?.triviaSubmitAnswer?.choiceId ?? null;
}

export function choiceIdForQuestion(
  answers: Array<{ questionId: string; choiceId: string }> | null | undefined,
  questionId: string | undefined,
): string | null {
  if (!questionId) return null;
  return (
    answers?.find((row) => row.questionId === questionId)?.choiceId ?? null
  );
}

export function shouldShowTriviaFanMissed({
  rejected,
  status,
  myPick,
  showFanReveal,
}: {
  rejected: boolean;
  status: string;
  myPick: string | null;
  showFanReveal: boolean;
}): boolean {
  if (myPick || showFanReveal) return false;
  if (rejected) return true;
  return status === 'QUESTION_CLOSED';
}
